import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';

const LoadingScreen = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '1.2rem',
    }}
  >
    Authenticating...
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { currentUser, authLoading } = useAuth(); // Access authLoading to avoid premature redirects
  const { userProfile } = useData(); // 2. Get userProfile

  if (authLoading) {
    return <LoadingScreen />;
  }

  console.log(
    'ProtectedRoute: currentUser emailVerified:',
    currentUser?.emailVerified,
  );

  if (!currentUser) {
    // If user is not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }

  // 🛡️ 3. THE FIX: Allow if Firebase verified OR if Impersonated
  const isActuallyVerified =
    currentUser.emailVerified || userProfile?.isImpersonated === true;

  if (!isActuallyVerified) {
    console.log('ProtectedRoute: Access denied, redirecting to verify-email');
    return <Navigate to="/verify-email" replace />;
  }

  // If logged in and email verified, render the child components (protected content)
  return children;
};

export default ProtectedRoute;
